export default __webpack_public_path__ + "static/media/plus13-20.64181d63.png";